import type { Shipments } from '#types/components/checkout/order'

/**
 * Filters unique shipments for specified delivery type (sth / pickup) and common properties
 * @param deliveryType - delivery type for filtered shipments (STH / PICKUP)
 * @param shipments - all shipments stored on order object
 * @returns unique shipments of specified delivery type
 * @category Utils
 */
export const getUniqueShipments = (
  deliveryType: 'STH' | 'PICKUP',
  shipments: Shipments[]
): Shipments[] => {
  const uniqueShipmentSignatures: string[] = []
  return shipments
    .reduce<Shipments[]>((result, shipment) => {
      const { shippingMethod: { code, deliveryTime, price } } = shipment
      if (deliveryType === 'STH' && isPickupOrSts(code)) return result
      if (deliveryType === 'PICKUP' && !isPickupOrSts(code)) return result
      const shipmentSignature = `${code}:${deliveryTime}:${price.amount}`
      if (uniqueShipmentSignatures.includes(shipmentSignature)) {
        return result // skip shipments with duplicated signature
      }
      uniqueShipmentSignatures.push(shipmentSignature)
      return [...result, shipment]
    }, [])
}
